import { Order } from "@/shared/api/lod-api";
import { SORT_DIRECTIONS, TIMELINE_ITEM_COLORS } from "./consts";
import { DateRange } from "react-day-picker";
import { PREDICTION_TYPES } from "@/entities/annotation/model/consts";
import { CustomerAction } from "@/entities/annotation";
import { RelativeCoordinate } from "@/shared/types";
import { DataGroup } from "vis-timeline";

export enum OrderStatus {
  Pending = "pending",
  Archived = "archived",
  Finished = "finished",
}

export type SortDirection =
  (typeof SORT_DIRECTIONS)[keyof typeof SORT_DIRECTIONS];

export interface OrderFilters {
  source: SourceKey;
  dateRange: DateRange | null;
  orderId: string;
  sortDirection: SortDirection;
}

type SourceKey = Order["order_source"];

export interface SourceOption {
  key: SourceKey;
  value: string;
}

export type TimelineItemColor =
  (typeof TIMELINE_ITEM_COLORS)[keyof typeof TIMELINE_ITEM_COLORS];

export interface PinBasedPredictionJson {
  result: {
    order_id: string;
    request_id?: string;
    type: "pin";
    request_time?: string;
    updates: {
      [journeyId: string]: PinBasedPredictionRecord[];
    };
  };
}

export type ZoneBasedPredictionJson = {
  result: {
    order_id: string;
    request_id: string;
    type: "zone";
    request_time: string;
    updates: {
      [trackId: string]: ZoneBasedPredictionRecord[];
    };
  };
};

export type PinBasedPredictionRecord = {
  track_id: number;
  name: string;
  barcode: string;
  image_url: string;
  variant_id: string;
  sku_base_id: number;
  update_time: string;
  update_type: "add" | "remove";
  update_quantity: number;
  gondola_id?: number;
  gondola_name?: string;
  camera_image_height?: number;
  camera_image_width?: number;
  pin2d_xy?: [number, number];
  camera_local_id?: number;
  calibration_id?: number;
  update_change_start_time?: string;
  update_change_end_time?: string;
  update_change_camera_local_id?: number;
  uom: string;
};

export type PinBasedPrediction = {
  id: string;
  type: typeof PREDICTION_TYPES.PIN;
  orderId: string;
  journeyId: string;
  name: string;
  barcode: string;
  imageUrl: string;
  variantId: string;
  skuId: number;
  timestamp: string;
  action: CustomerAction;
  count: number;
  trackId?: number;
  gondolaId?: number;
  gondolaName?: string;
  cameraImageHeight?: number;
  cameraImageWidth?: number;
  pinCoordinates?: RelativeCoordinate;
  cameraId?: number;
  calibrationId?: number;
  updateChangeStartTime?: string;
  updateChangeEndTime?: string;
  updateChangeCameraId?: number;
  uom: string;
};

export type ZoneBasedPredictionRecord = {
  name: string;
  barcode: string;
  image_url: string;
  variant_id: string;
  sku_base_id: number;
  update_time: string;
  update_type: "add" | "remove";
  update_quantity: number;
  gondola_id?: number;
  gondola_name?: string;
  camera_image_height?: number;
  camera_image_width?: number;
  pin2d_xy?: [number, number];
  camera_local_id?: number;
  calibration_id?: number;
  update_change_start_time?: string;
  update_change_end_time?: string;
  update_change_camera_local_id?: number;
  uom: string;
};

export type ZoneBasedPrediction = {
  id: string;
  type: typeof PREDICTION_TYPES.ZONE;
  orderId: string;
  trackId: string;
  name: string;
  barcode: string;
  imageUrl: string;
  variantId: string;
  skuId: number;
  timestamp: string;
  action: CustomerAction;
  count: number;
  gondolaId?: number;
  gondolaName?: string;
  cameraImageHeight?: number;
  cameraImageWidth?: number;
  pinCoordinates?: RelativeCoordinate;
  cameraId?: number;
  calibrationId?: number;
  updateChangeStartTime?: string;
  updateChangeEndTime?: string;
  updateChangeCameraId?: number;
  uom: string;
};

export interface TimelineGroupType extends DataGroup {
  id: string;
  content: string;
  color?: string;
  isHidden?: boolean;
  isSaved?: boolean;
  canHide?: boolean;
  canSave?: boolean;
  parentGroup?: string;
  showNested?: boolean;
  nestedGroups?: string[];
  order?: number;
}

export type CartItem = {
  skuId: number;
  name: string;
  barcode: string;
  quantity: number;
  imageUrl: string;
  uom: string;
};
